import {
  LinearGradient,
  Image,
  SimpleText,
  YStack,
  ActionButton,
  Spinner,
  useWindowDimensions,
  XStack,
  TZACardStyle,
} from '@my/ui'
import images from '../../../assets/images'
import { useState } from 'react'
import { AnswerButton } from '../helper'
import { color, TZABrandGuidelines } from '@my/util'

export const QuestionOfDaySection: React.FC<QuestionOfDaySectionProps> = (props) => {
  const { questionOfDay, handleAnswerPress, isAnswerRevealed } = props || {}
  const { question, answers, correctAnswer, explanation, dailyTip } = questionOfDay || {}
  const [showExplanation, setShowExplanation] = useState(false)
  const { width } = useWindowDimensions()

  const [selectedAnswer, setSelectedAnswer] = useState(props.selectedAnswer);

  const onAnswerPress = (key: string, answer: string) => {
    setSelectedAnswer(answer);
    handleAnswerPress(key);
  }

  const renderAnswers = Object.entries(answers || {}).map(([key, answer], index) => (
    <AnswerButton
      key={index}
      index={index}
      answer={answer}
      onPress={() => onAnswerPress(key, answer)}
      isSelected={selectedAnswer === answer}
      isCorrect={correctAnswer === key}
      isRevealed={isAnswerRevealed}
    />
  ))

  const renderAnswerDetails = (!showExplanation) 
  ? null
  : (
      <YStack gap={10} style={{backgroundColor: 'white', padding: 10, ...TZACardStyle}}>
        <SectionTitle text="Answer" />
        <SimpleText fontSize={14}>
          {explanation}
        </SimpleText>
        <SectionTitle text="Daily TIP" />
        <SimpleText fontSize={14}>
          {dailyTip}
        </SimpleText>
      </YStack>
    )

  const renderLearnMoreButton = (!isAnswerRevealed)
  ? null
  : (
    <ActionButton
      //unstyled

      onPress={() => setShowExplanation(!showExplanation)}
      hoverStyle={{borderColor: 'rgba(108, 117, 125, 0.24)'}}
      pressStyle={{borderColor: 'rgba(108, 117, 125, 0.24)'}}
      style={{
        borderStyle: 'solid',
        borderWidth: 1,
        borderColor: 'rgba(108, 117, 125, 0.24)',
        borderRadius: 10,
        fontSize: 12,
        fontWeight: 700,
        backgroundColor: TZABrandGuidelines.colorsMap.tertiaryCornSilk,
        //flex={1}
        height: 38,
        width:120,
        justifyContent: 'center',
        alignItems: 'center',
        marginVertical: 15
      }}
    >
      Learn More
    </ActionButton>
  )
  

  const renderQuestionContent = (!question) 
  ? <Spinner size="large" mt={20} color={color.white} />
  : (
    <>
      <SimpleText
        marginVertical="$4"
        color="rgb(255, 255, 255)"
        style={{textShadow: '#0000003f 1px 0 2px', textAlign: 'center' }}
        $platform-web={{ fontSize: 22 }}
        fontSize={24}
        fontWeight="400"
        alignSelf="center"
      >
        {question}
      </SimpleText>
      <YStack justifyContent="space-between" gap={15} alignItems="center" >
        {renderAnswers}
      </YStack>
      {renderLearnMoreButton}
    </>
  )

  return (
    <YStack
      position='relative'
      backgroundImage={'linear-gradient(45deg, #699A7D 0%, #85C19D 100%)'}
      //colors={['#699A7D', '#85C19D']}
      //colors={['rgba(105, 154, 125, 0.2)', 'rgba(133, 193, 157, 0.2))']}
      //start={[0, 1]}
      //end={[1, 0]}
      borderRadius={15}
      style={{
        borderWidth: 1, borderStyle: 'solid',
        borderColor: TZACardStyle.borderColor, borderRadius: TZACardStyle.borderRadius,
        overflow: 'hidden'
      }}
      padding={15}
      alignItems='center'
      marginHorizontal='$4'
    >
      {/* <Image
        src={images.ellipse}
        //position="absolute"
        //right={0}
        resizeMode="contain"
        $platform-web={{ 
          position: 'absolute',
          height: 80, width: 90, top: 0, right: -40
        }}
      /> */}
      <XStack justifyContent='center' 
       // borderBottomWidth={2} border="1px solid" borderColor={color.tzaGreen}
      >
        <SimpleText
          color="rgb(255, 255, 255)" fontSize={28} fontWeight="500" alignSelf="center"
          style={{textShadow: '#00000069 1px 0 4px', zIndex: 1 }}
        >
          Question of the Day
        </SimpleText>
      </XStack>
      <YStack
        gap={15}
        $platform-web={{
          width: width < 800 ? '100%' : '75%',
          alignSelf: 'center',
          //zIndex: 1
        }}
      >
        {renderQuestionContent}
        {renderAnswerDetails}
      </YStack>
    </YStack>
  )
}

// Reusable component for section titles
const SectionTitle = ({ text }: { text: string }) => (
  <SimpleText fontSize={16} fontWeight="700">
    {text}
  </SimpleText>
)
